import  type { ConstantEnum } from "src/store/types";

export const siteIdEnum: ConstantEnum = {
  en: "1",
  es: "2",
  pt: "3",
  ru: "4",
  fr: "5",
  de: "6",
  cn: "7",
  tw: "8",
  jp: "9",
  id: "10",
  it: "11",
  th: "12",
  vi: "13",
  tr: "14",
  pl: "15",
  nl: "16",
};

export const languageBySiteId: ConstantEnum = {
  "1": "en",
  "2": "es",
  "3": "pt",
  "4": "ru",
  "5": "fr",
  "6": "de",
  "7": "cn",
  "8": "tw",
  "9": "jp",
  "10": "id",
  "11": "it",
  "12": "th",
  "13": "vi",
  "14": "tr",
  "15": "pl",
  "16": "nl",
};

export const languageBySiteIdFull: ConstantEnum = {
  "1": "en_US",
  "2": "es_ES",
  "3": "pt_BR",
  "4": "ru_RU",
  "5": "fr_FR",
  "6": "de_DE",
  "7": "zh_CN",
  "8": "zh_TW",
  "9": "ja_JP",
  "10": "id_ID",
  "11": "it_IT",
  "12": "th_TH",
  "13": "vi_VN",
  "14": "tr_TR",
  "15": "pl_PL",
  "16": "nl_NL",
};

export const hrefLangSite: ConstantEnum = {
  "1": "en-us",
  "2": "es-es",
  "3": "pt-br",
  "4": "ru-ru",
  "5": "fr-fr",
  "6": "de-de",
  "7": "zh-cn",
  "8": "zh-tw",
  "9": "ja-jp",
  "10": "id-id",
  "11": "it-it",
  "12": "th-th",
  "13": "vi-vn",
  "14": "tr-tr",
  "15": "pl-pl",
  "16": "nl-nl",
};


export default siteIdEnum;
